<template>
  <div class="photo-gallery" ref="scroller">
    <h1>Photo Gallery
      <el-button type="info" v-if="mode === 'pick'" @click="$emit('view', 'mainscreen')">Close Gallery</el-button>
    </h1>

    <input ref="imageuploader" type="file" style="display: none;" multiple accept="image/*" @change="(e) => { files = e.target.files; $forceUpdate() }" />
    <!-- <pre>{{ files }}</pre> -->
    <div>
      <el-button type="success" @click="$refs['imageuploader'].click()">Select Images to be Uploaded</el-button>
      <el-button type="primary" v-if="files && files.length > 0" @click="goUpload">Upload {{ files.length }} Images</el-button>
      <h1 v-if="remainPhotos && remainPhotos > 0"> Uploading... {{ remainPhotos }} Image(s) Left...</h1>
    </div>

    <div v-if="mode === 'view'">
      <el-button type="info" v-if="images.length > 0 && toggle === 'selectAll'" @click="selectAll">Select All</el-button>
      <el-button type="info" v-if="images.length > 0 && toggle === 'cancelAll'" @click="cancelAll">Cancel All</el-button>

      <el-button type="danger" v-if="images.filter(e => e.selected === true).length > 0" @click="removeImages">Remove Selected</el-button>
    </div>

    <!--
    <div>
      <span :key="img._id" v-for="img in selectedImages">
        {{ img._id }}
      </span>
    </div>
    -->
    <ul v-if="mode === 'view'">
      <li :key="img._id" v-for="(img, iimg) in images">
        <input type="checkbox" v-model="img.selected" :id="'_label_' + img._id" @change="$forceUpdate()" />

        <label :for="'_label_' + img._id" :ref="'_label_' + img._id" style="cursor: pointer;">
          <img v-if="iimg < 25 && img.s3[0] || img.show" style="max-width: 50px; max-height: 50px; min-height: 50px; transform: translateY(12px);" :src="img.s3[0].location" @mouseenter="hover.img = img.s3[0].location" @mouseleave="hover.img = false">
          <div v-if="iimg >= 25 && img.s3[0] && !img.show" style="display: inline-block; width: 50px; height: 50px; background-color: grey; cursor: pointer;" @click="img.show = true; $forceUpdate()" @mouseenter="img.show = true; $forceUpdate()" />
        </label>

        <el-input :value="img.s3[0].location" style="width:100px;max-width:100%;"/>
        <el-button type="primary" @click="copyLink(img.s3[0].location, $event)">copy link</el-button>
        <el-button type="info" @click="copyMD(img.s3[0].location, $event)">markdown</el-button>
        <el-button type="info" @click="copyHTML(img.s3[0].location, $event)">html</el-button>
        <el-button type="warning" @click="download(img.s3[0].location)">Download</el-button>
      </li>
    </ul>

    <div class="picker-grid" v-if="mode === 'pick'">
      <div class="picker" :for="'_label_' + img._id" :ref="'_label_' + img._id" @click="$emit('imgsrc', img.s3[0].location); $emit('view', 'mainscreen')" style="cursor: pointer;" :key="img._id" v-for="(img, iimg) in images" @mouseenter="hover.img = img.s3[0].location" @mouseleave="hover.img = false">
        <div style="display: inline-block; min-height: 105px; margin: 5px; border: grey solid 1px; box-sizing: border-box;">
          <img v-if="iimg < 25 && img.s3[0] || img.show" style="max-width: 101px; max-height: 101px;" :src="img.s3[0].location" >
        </div>
        <div v-if="iimg >= 25 && img.s3[0] && !img.show" style="display: inline-block; width: 101px; height: 101px; background-color: grey; cursor: pointer;" @click="img.show = true; $forceUpdate()" @mouseenter="img.show = true; $forceUpdate()" />
      </div>
    </div>

    <img :src="hover.img" ref="hoverImg" style="position: fixed; max-width: 400px; max-height: 400px;">
    <!-- <pre>{{ images }}</pre> -->
    <div style="height: 60vh;"></div>
  </div>
</template>

<script>
import clip from '@/utils/clipboard' // use clipboard directly
import downscale from 'downscale'
import { uploadImage, listImages, removeImages } from '@/api/photos'

var isInViewport = (elem) => {
  var bounding = elem.getBoundingClientRect()
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export default {
  components: {
  },
  props: {
    mode: {
      default: 'view'
    }
  },
  data() {
    return {
      hover: {
        img: false,
        pageX: 0,
        pageY: 0
      },
      toggle: 'selectAll',
      remainPhotos: 0,
      files: false,
      images: []
    }
  },
  computed: {
    selectedImages() {
      return this.images.filter(e => e.selected === true)
    }
  },
  mounted() {
    this.listImages()
    let tt = 0
    window.addEventListener('scroll', () => {
      clearTimeout(tt)
      tt = setTimeout(() => {
        this.images.forEach(img => {
          const row = this.$refs['_label_' + img._id][0]
          if (row && isInViewport(row)) {
            img.show = true
          }
        })
        this.$forceUpdate()
      }, 30)
    })

    window.addEventListener('mousemove', (evt) => {
      // console.log(evt)
      this.hover = {
        ...this.hover,
        pageX: evt.pageX,
        pageY: evt.pageY
      }

      let img = this.$refs['hoverImg']
      let scroller = this.$refs['scroller']
      if (!img) {return}

      if (evt.pageX + img.width > window.innerWidth) {
        img.style.right = (window.innerWidth - evt.pageX - 10) + 'px'
      } else {
        img.style.left = (evt.pageX + 10) + 'px'
      }

      img.style.top = (evt.pageY + 10 - window.scrollY) + 'px'

      if (this.hover.img) {
        img.style.display = 'block'
      } else {
        img.style.display = 'none'
      }
    })
  },
  methods: {
    download (url) {
      window.open(url)
    },
    cancelAll() {
      this.images.forEach(i => { i.selected = false })
      this.$forceUpdate()
      this.toggle = 'selectAll'
    },
    selectAll() {
      this.images.forEach(i => { i.selected = true })
      this.$forceUpdate()
      this.toggle = 'cancelAll'
    },
    copyLink(text, event) {
      clip(text, event)
    },
    copyMD(text, event) {
      clip(`!(My Image)[${text}]`, event)
    },
    copyHTML(text, event) {
      clip(`<img src="${text}" alt="my image" title="my image" />`, event)
    },
    removeImages() {
      // const count = this.selectedImages.length
      if (window.confirm('remove selected images?')) {
        this.$message({ message: 'Remove begin, may take some time...', type: 'success' })
        removeImages({
          includes: this.selectedImages.map(i => i._id)
        }).then((resp) => {
          this.listImages()
          this.$message({ message: 'Remove success', type: 'success' })
          console.log(resp.data)
        })
      }
    },
    uploadImage(fileObj) {
      if (!fileObj) {
        alert('Please select image')
        return
      }
      const formData = new FormData()
      // const fileObj = this.$refs.inputFile.files[0]

      let scanImage = () => {
        return new Promise((resolve) => {
          let url = URL.createObjectURL(fileObj)
          let image = new Image()
          image.onload = () => {
            resolve({ x: 1920, y: 1920 * (image.height / image.width) })
          }
          image.src = url
        })
      }

      return scanImage().then(({ x, y }) => {
        return downscale(fileObj, x, y, {returnBlob: 1})
      })
      .then((blob) => {
        formData.append('photos', blob, fileObj.name)
        return uploadImage(formData)
      })
    },
    listImages() {
      listImages().then((resp) => {
        this.images = resp.data
        this.$forceUpdate()
      })
    },
    goUpload() {
      if (this.files && this.files.length > 0) {
        this.remainPhotos = this.files.length
        const buck = []
        for (var i = 0; i < this.files.length; i++) {
          buck.push(this.files[i])
        }
        Promise.all(
          buck.map((file) => {
            return this.uploadImage(file)
              .then((resp) => {
                this.remainPhotos--
                return Promise.resolve(resp.data)
              })
          })
        ).then((photosFromDB) => {
          this.remainPhotos = 0
          this.listImages()
          // this.files = false
          console.log(photosFromDB)
        }).catch((e) => {
          this.listImages()
          console.log(e)
        })
      }
    }
  }
}
</script>

<style scoped>
.photo-gallery{
  position: relative;
  margin: 20px;

  overflow: auto;
  height: 100%;
}
.picker-grid{
  display: flex;
  flex-wrap: wrap;
}

</style>
